import { useAuth } from './useAuth';

export const useUserId = () => useAuth().tokenInfo?.user_id;
